<li>
  <div routerLinkActive="activeProject">
    <i role="none" (click)="toggleCollapse()" [ngClass]="item.children.length > 0 ? (!isCollapsed ? 'ri-folder-reduce-line' : 'ri-folder-add-line') : 'ri-folder-line'" class="align-bottom me-2"></i>
    <span role="none" class="pointer" routerLink="{{ item.id }}" (click)="goToProject()">{{ item.name }}</span>
  </div>
  @if (!isCollapsed && item.children) {
    <ul class="sub-menu list-unstyled">
      @for (child of item.children; track child) {
        <app-project-list-item [item]="child"></app-project-list-item>
      }
    </ul>
  }
</li>